import getAkamaiImageManagerSrc from './getAkamaiImageManagerSrc';
import { resolutionMapping } from '../constants';
/**
 * This function return src for a wrapProductImageImageManagerImage.
 *
 * @param src - The image src.
 * @param closestWidth - The image closestWidth width.
 * @returns - Return the image url.
 */
const wrapProductImageImageManagerImageSrc = (src, closestWidth) => {
    return getAkamaiImageManagerSrc(src, resolutionMapping[closestWidth]);
};
export default wrapProductImageImageManagerImageSrc;
//# sourceMappingURL=wrapProductImageImageManagerImageSrc.js.map